"use strict"; // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var _toConsumableArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var common_1 = require("../../common");

var Graphics = require("../../graphics");

var Specification = require("../../specification");

var chart_element_1 = require("../chart_element");

var common_2 = require("../common");

var axis_1 = require("../plot_segments/axis");

var LegendClass =
/*#__PURE__*/
function (_chart_element_1$Char) {
  _inherits(LegendClass, _chart_element_1$Char);

  function LegendClass() {
    var _this;

    _classCallCheck(this, LegendClass);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LegendClass).apply(this, arguments));
    _this.attributeNames = ["x", "y"];
    _this.attributes = {
      x: {
        name: "x",
        type: Specification.AttributeType.Number
      },
      y: {
        name: "y",
        type: Specification.AttributeType.Number
      }
    };
    return _this;
  }

  _createClass(LegendClass, [{
    key: "initializeState",
    value: function initializeState() {
      var attrs = this.state.attributes;
      attrs.x = 0;
      attrs.y = 0;
    }
  }, {
    key: "getLayoutBox",
    value: function getLayoutBox() {
      var _this$state$attribute = this.state.attributes,
          x = _this$state$attribute.x,
          y = _this$state$attribute.y;

      var _this$getLegendSize = this.getLegendSize(),
          _this$getLegendSize2 = _slicedToArray(_this$getLegendSize, 2),
          width = _this$getLegendSize2[0],
          height = _this$getLegendSize2[1];

      var x1, y1, x2, y2;

      switch (this.object.properties.alignX) {
        case "start":
          x1 = x;
          x2 = x + width;
          break;

        case "middle":
          x1 = x - width / 2;
          x2 = x + width / 2;
          break;

        case "end":
          x1 = x - width;
          x2 = x;
          break;
      }

      switch (this.object.properties.alignY) {
        case "start":
          y1 = y;
          y2 = y + height;
          break;

        case "middle":
          y1 = y - height / 2;
          y2 = y + height / 2;
          break;

        case "end":
          y1 = y - height;
          y2 = y;
          break;
      }

      return {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
      };
    }
  }, {
    key: "getBoundingBox",
    value: function getBoundingBox() {
      var attrs = this.state.attributes;

      var _this$getLayoutBox = this.getLayoutBox(),
          x1 = _this$getLayoutBox.x1,
          y1 = _this$getLayoutBox.y1,
          x2 = _this$getLayoutBox.x2,
          y2 = _this$getLayoutBox.y2;

      return {
        type: "rectangle",
        cx: (x1 + x2) / 2,
        cy: (y1 + y2) / 2,
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1),
        rotation: 0
      };
    }
  }, {
    key: "getHandles",
    value: function getHandles() {
      var attrs = this.state.attributes;
      var x = attrs.x,
          y = attrs.y;
      return [{
        type: "point",
        x: x,
        y: y,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "x"
        }, {
          type: "attribute",
          source: "y",
          attribute: "y"
        }]
      }];
    }
  }, {
    key: "getScale",
    value: function getScale() {
      var scale = this.object.properties.scale;
      var scaleIndex = common_1.indexOf(this.parent.object.scales, function (x) {
        return x._id == scale;
      });

      if (scaleIndex >= 0) {
        return [this.parent.object.scales[scaleIndex], this.parent.state.scales[scaleIndex]];
      } else {
        return null;
      }
    }
  }, {
    key: "getLegendSize",
    value: function getLegendSize() {
      return [10, 10];
    }
  }, {
    key: "getAttributePanelWidgets",
    value: function getAttributePanelWidgets(manager) {
      var props = this.object.properties;
      return [manager.sectionHeader("Alignment"), manager.row("Horizontal", manager.inputSelect({
        property: "alignX"
      }, {
        type: "radio",
        icons: ["align/left", "align/x-middle", "align/right"],
        labels: ["Left", "Middle", "Right"],
        options: ["start", "middle", "end"]
      })), manager.row("Vertical", manager.inputSelect({
        property: "alignY"
      }, {
        type: "radio",
        icons: ["align/top", "align/y-middle", "align/bottom"],
        labels: ["Top", "Middle", "Bottom"],
        options: ["end", "middle", "start"]
      })), manager.sectionHeader("Labels"), manager.row("Font", manager.inputFontFamily({
        property: "fontFamily"
      })), manager.row("Size", manager.inputNumber({
        property: "fontSize"
      }, {
        showUpdown: true,
        updownStyle: "font",
        updownTick: 2
      })), manager.row("Color", manager.inputColor({
        property: "textColor"
      }))];
    }
  }]);

  return LegendClass;
}(chart_element_1.ChartElementClass);

LegendClass.metadata = {
  displayName: "Legend",
  iconPath: "legend/legend"
};
LegendClass.defaultProperties = {
  visible: true,
  alignX: "start",
  alignY: "end",
  fontFamily: "Arial",
  fontSize: 14,
  textColor: {
    r: 0,
    g: 0,
    b: 0
  }
};
exports.LegendClass = LegendClass;

function getMatches(str) {
  var alwaysArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var matches = [];
  var regex = /\(([^\(\)]*)\)/g;
  var match;

  while (match = regex.exec(str)) {
    matches.push(match[1]);
  }

  if (!alwaysArray && matches.length == 1) {
    return matches[0];
  }

  return matches;
}

var CategoricalLegendClass =
/*#__PURE__*/
function (_LegendClass) {
  _inherits(CategoricalLegendClass, _LegendClass);

  function CategoricalLegendClass() {
    var _this2;

    _classCallCheck(this, CategoricalLegendClass);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(CategoricalLegendClass).apply(this, arguments));
    _this2.textMeasure = new Graphics.TextMeasurer();
    return _this2;
  }

  _createClass(CategoricalLegendClass, [{
    key: "getLegendItems",
    value: function getLegendItems() {
      var scale = this.getScale();

      if (scale) {
        var _scale = _slicedToArray(scale, 2),
            scaleObject = _scale[0],
            scaleState = _scale[1];

        var mapping = scaleObject.properties.mapping;
        var items = [];

        for (var key in mapping) {
          if (mapping.hasOwnProperty(key)) {
            switch (scaleObject.classID) {
              case "scale.categorical<string,boolean>":
                {
                  items.push({
                    type: "boolean",
                    label: key,
                    value: mapping[key]
                  });
                }
                break;

              case "scale.categorical<string,number>":
                {
                  items.push({
                    type: "number",
                    label: key,
                    value: mapping[key]
                  });
                }
                break;

              case "scale.categorical<string,color>":
                {
                  items.push({
                    type: "color",
                    label: key,
                    value: mapping[key]
                  });
                }
                break;
            }
          }
        }

        items.sort(function (a, b) {
          return a.label < b.label ? -1 : 1;
        });
        return items;
      } else {
        return [];
      }
    }
  }, {
    key: "getLineHeight",
    value: function getLineHeight() {
      return this.object.properties.fontSize + 10;
    }
  }, {
    key: "getLegendSize",
    value: function getLegendSize() {
      var items = this.getLegendItems();
      return [100, items.length * this.getLineHeight()];
    }
  }, {
    key: "getGraphics",
    value: function getGraphics() {
      var fontFamily = this.object.properties.fontFamily;
      var fontSize = this.object.properties.fontSize;
      var lineHeight = this.getLineHeight();
      this.textMeasure.setFontFamily(fontFamily);
      this.textMeasure.setFontSize(fontSize);
      var g = Graphics.makeGroup([]);
      var items = this.getLegendItems();
      var scaleIdentity = this.object.properties.scale;
      var legendBind = {
        _TYPE: "legend"
      };
      this.parent.manager.chart.glyphs.forEach(function (glyph) {
        glyph.marks.forEach(function (mark) {
          Object.keys(mark.mappings).forEach(function (key) {
            if (mark.mappings[key].type == "scale") {
              var mapping = mark.mappings[key];

              if (mapping.scale == scaleIdentity) {
                if (legendBind[key]) {
                  if (typeof legendBind[key] === "string") {
                    legendBind[key] = [legendBind[key]];
                  }

                  legendBind[key] = legendBind[key].concat(getMatches(mapping.expression, true));
                } else {
                  legendBind[key] = getMatches(mapping.expression);
                }
              }
            }
          });
        });
      });

      if (legendBind.fill || legendBind.stroke) {
        var color = [];
        var types = ["fill", "stroke"];
        types.forEach(function (t) {
          if (!legendBind[t]) {
            return;
          }

          if (typeof legendBind[t] === "string") {
            color.push(legendBind[t]);
          } else {
            color = [].concat(_toConsumableArray(color), _toConsumableArray(legendBind[t]));
          }
        });

        if (color.length == 1) {
          legendBind.color = color[0];
        } else {
          legendBind.color = color;
        }
      }

      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var metrics = this.textMeasure.measure(item.label);
        var offsets = Graphics.TextMeasurer.ComputeTextPosition(lineHeight, lineHeight / 2, metrics, "left", "middle", 5, 0);
        var textLabel = Graphics.makeText(offsets[0], offsets[1], item.label, fontFamily, fontSize, {
          fillColor: this.object.properties.textColor
        });
        var gItem = Graphics.makeGroup([textLabel]);

        switch (item.type) {
          case "color":
            {
              gItem.elements.push(Graphics.makeRect(8, 4, lineHeight, lineHeight - 4, {
                fillColor: item.value
              }));
            }
            break;
        }

        gItem.transform = {
          x: 0,
          y: lineHeight * (items.length - 1 - i),
          angle: 0
        };
        g.elements.push(gItem);
      }

      var _this$getLayoutBox2 = this.getLayoutBox(),
          x1 = _this$getLayoutBox2.x1,
          y1 = _this$getLayoutBox2.y1;

      g.transform = {
        x: x1,
        y: y1,
        angle: 0
      };
      g["data-datum"] = JSON.stringify(legendBind);
      return g;
    }
  }]);

  return CategoricalLegendClass;
}(LegendClass);

CategoricalLegendClass.classID = "legend.categorical";
CategoricalLegendClass.type = "legend";
exports.CategoricalLegendClass = CategoricalLegendClass;

var NumericalColorLegendClass =
/*#__PURE__*/
function (_LegendClass2) {
  _inherits(NumericalColorLegendClass, _LegendClass2);

  function NumericalColorLegendClass() {
    _classCallCheck(this, NumericalColorLegendClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(NumericalColorLegendClass).apply(this, arguments));
  }

  _createClass(NumericalColorLegendClass, [{
    key: "getLegendSize",
    value: function getLegendSize() {
      return [100, 100];
    }
  }, {
    key: "getGraphics",
    value: function getGraphics() {
      var height = this.getLegendSize()[1];
      var marginLeft = 5;
      var gradientWidth = 12;
      var scale = this.getScale();

      if (!scale) {
        return null;
      }

      var scaleIdentity = this.object.properties.scale;
      var legendBind = {
        _TYPE: "legend"
      };
      this.parent.manager.chart.glyphs.forEach(function (glyph) {
        glyph.marks.forEach(function (mark) {
          Object.keys(mark.mappings).forEach(function (key) {
            if (mark.mappings[key].type == "scale") {
              var mapping = mark.mappings[key];

              if (mapping.scale == scaleIdentity) {
                if (legendBind[key]) {
                  if (typeof legendBind[key] === "string") {
                    legendBind[key] = [legendBind[key]];
                  }

                  legendBind[key] = legendBind[key].concat(getMatches(mapping.expression, true));
                } else {
                  legendBind[key] = getMatches(mapping.expression);
                }
              }
            }
          });
        });
      });

      if (legendBind.fill || legendBind.stroke) {
        var color = [];
        var types = ["fill", "stroke"];
        types.forEach(function (t) {
          if (!legendBind[t]) {
            return;
          }

          if (typeof legendBind[t] === "string") {
            color.push(legendBind[t]);
          } else {
            color = [].concat(_toConsumableArray(color), _toConsumableArray(legendBind[t]));
          }
        });

        if (color.length == 1) {
          legendBind.color = color[0];
        } else {
          legendBind.color = color;
        }
      }

      var range = scale[0].properties.range;
      var domainMin = scale[0].properties.domainMin;
      var domainMax = scale[0].properties.domainMax;
      var axisRenderer = new axis_1.AxisRenderer();
      axisRenderer.setLinearScale(domainMin, domainMax, 0, height, null);
      axisRenderer.setStyle({
        tickColor: this.object.properties.textColor,
        fontSize: this.object.properties.fontSize,
        fontFamily: this.object.properties.fontFamily,
        lineColor: this.object.properties.textColor
      });
      var g = Graphics.makeGroup([]);
      g.elements.push(axisRenderer.renderLine(marginLeft + gradientWidth + 2, 0, 90, 1));
      var ticks = height * 2;
      var interp = common_1.interpolateColors(range.colors, range.colorspace);

      for (var i = 0; i < ticks; i++) {
        var t = (i + 0.5) / ticks;

        var _color = interp(t);

        var _y = i / ticks * height;

        var y2 = Math.min(height, (i + 1.5) / ticks * height);
        g.elements.push(Graphics.makeRect(marginLeft, _y, marginLeft + gradientWidth, y2, {
          fillColor: _color
        }));
      }

      var _this$getLayoutBox3 = this.getLayoutBox(),
          x1 = _this$getLayoutBox3.x1,
          y1 = _this$getLayoutBox3.y1;

      g.transform = {
        x: x1,
        y: y1,
        angle: 0
      };
      g["data-datum"] = JSON.stringify(legendBind);
      return g;
    }
  }]);

  return NumericalColorLegendClass;
}(LegendClass);

NumericalColorLegendClass.classID = "legend.numerical-color";
NumericalColorLegendClass.type = "legend";
exports.NumericalColorLegendClass = NumericalColorLegendClass;

var NumericalNumberLegendClass =
/*#__PURE__*/
function (_chart_element_1$Char2) {
  _inherits(NumericalNumberLegendClass, _chart_element_1$Char2);

  function NumericalNumberLegendClass() {
    var _this3;

    _classCallCheck(this, NumericalNumberLegendClass);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(NumericalNumberLegendClass).apply(this, arguments));
    _this3.attributeNames = ["x1", "y1", "x2", "y2"];
    _this3.attributes = {
      x1: {
        name: "x1",
        type: Specification.AttributeType.Number
      },
      y1: {
        name: "y1",
        type: Specification.AttributeType.Number
      },
      x2: {
        name: "x2",
        type: Specification.AttributeType.Number
      },
      y2: {
        name: "y2",
        type: Specification.AttributeType.Number
      }
    };
    return _this3;
  }

  _createClass(NumericalNumberLegendClass, [{
    key: "initializeState",
    value: function initializeState() {
      var attrs = this.state.attributes;
      attrs.x1 = 0;
      attrs.y1 = 0;
      attrs.x2 = 0;
      attrs.y2 = 0;
    }
  }, {
    key: "getScale",
    value: function getScale() {
      var scale = this.object.properties.scale;
      var scaleIndex = common_1.indexOf(this.parent.object.scales, function (x) {
        return x._id == scale;
      });

      if (scaleIndex >= 0) {
        return [this.parent.object.scales[scaleIndex], this.parent.state.scales[scaleIndex]];
      } else {
        return null;
      }
    }
  }, {
    key: "getBoundingBox",
    value: function getBoundingBox() {
      return {
        type: "line",
        x1: this.state.attributes.x1,
        y1: this.state.attributes.y1,
        x2: this.state.attributes.x2,
        y2: this.state.attributes.y2
      };
    }
  }, {
    key: "getHandles",
    value: function getHandles() {
      var attrs = this.state.attributes;
      var x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2;
      return [{
        type: "point",
        x: x1,
        y: y1,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "x1"
        }, {
          type: "attribute",
          source: "y",
          attribute: "y1"
        }]
      }, {
        type: "point",
        x: x2,
        y: y2,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "x2"
        }, {
          type: "attribute",
          source: "y",
          attribute: "y2"
        }]
      }];
    }
  }, {
    key: "getGraphics",
    value: function getGraphics() {
      var scale = this.getScale();

      if (!scale) {
        return null;
      }

      if (!this.object.properties.axis.visible) {
        return null;
      }

      var scaleIdentity = this.object.properties.scale;
      var legendBind = {
        _TYPE: "legend"
      };
      this.parent.manager.chart.glyphs.forEach(function (glyph) {
        glyph.marks.forEach(function (mark) {
          Object.keys(mark.mappings).forEach(function (key) {
            if (mark.mappings[key].type == "scale") {
              var mapping = mark.mappings[key];

              if (mapping.scale == scaleIdentity) {
                if (legendBind[key]) {
                  if (typeof legendBind[key] === "string") {
                    legendBind[key] = [legendBind[key]];
                  }

                  legendBind[key] = legendBind[key].concat(getMatches(mapping.expression, true));
                } else {
                  legendBind[key] = getMatches(mapping.expression);
                }
              }
            }
          });
        });
      });

      if (legendBind.fill || legendBind.stroke) {
        var color = [];
        var types = ["fill", "stroke"];
        types.forEach(function (t) {
          if (!legendBind[t]) {
            return;
          }

          if (typeof legendBind[t] === "string") {
            color.push(legendBind[t]);
          } else {
            color = [].concat(_toConsumableArray(color), _toConsumableArray(legendBind[t]));
          }
        });

        if (color.length == 1) {
          legendBind.color = color[0];
        } else {
          legendBind.color = color;
        }
      }

      var rangeMin = scale[1].attributes.rangeMin;
      var rangeMax = scale[1].attributes.rangeMax;
      var domainMin = scale[0].properties.domainMin;
      var domainMax = scale[0].properties.domainMax;
      var dx = this.state.attributes.x2 - this.state.attributes.x1;
      var dy = this.state.attributes.y2 - this.state.attributes.y1;
      var length = Math.sqrt(dx * dx + dy * dy);
      var renderer = new axis_1.AxisRenderer(); // Extend/shrink range, and update the domain accordingly. Keep the scaling factor.

      var scaling = (rangeMax - rangeMin) / (domainMax - domainMin);
      renderer.setLinearScale(domainMin, domainMin + (length - rangeMin) / scaling, rangeMin, length, null);
      renderer.setStyle(this.object.properties.axis.style);
      var g = renderer.renderLine(this.state.attributes.x1, this.state.attributes.y1, Math.atan2(dy, dx) / Math.PI * 180, -1);
      g["data-datum"] = JSON.stringify(legendBind);
      return g;
    }
  }, {
    key: "getAttributePanelWidgets",
    value: function getAttributePanelWidgets(manager) {
      var props = this.object.properties;
      return [manager.sectionHeader("Axis"), axis_1.buildAxisAppearanceWidgets(props.axis.visible, "axis", manager)];
    }
  }]);

  return NumericalNumberLegendClass;
}(chart_element_1.ChartElementClass);

NumericalNumberLegendClass.classID = "legend.numerical-number";
NumericalNumberLegendClass.type = "legend";
NumericalNumberLegendClass.metadata = {
  displayName: "Legend",
  iconPath: "legend/legend"
};
NumericalNumberLegendClass.defaultProperties = {
  visible: true,
  axis: {
    side: "default",
    visible: true,
    style: common_1.deepClone(axis_1.defaultAxisStyle)
  }
};
exports.NumericalNumberLegendClass = NumericalNumberLegendClass;

function registerClasses() {
  common_2.ObjectClasses.Register(CategoricalLegendClass);
  common_2.ObjectClasses.Register(NumericalColorLegendClass);
  common_2.ObjectClasses.Register(NumericalNumberLegendClass);
}

exports.registerClasses = registerClasses;